export function reduce(source: Float32Array, count = 1000): Float32Array {
  const step = source.length / count
  const target = new Float32Array(count)

  for (let chunk = 0; chunk < count; chunk++) {
    const f = chunk * step
    const from = Math.trunc(f)
    const to = Math.trunc(f + step)
    let sum = 0
    for (let i = from; i < to; i++) {
      sum += Math.abs(source[i])
    }
    const chunkLength = to - from
    target[chunk] = chunkLength ? sum / chunkLength : sum
  }

  return target
}
